export default "__VITE_ASSET__BEKgKKIx__"